<template>
    <!--
      	作者：kmdshop
      	时间：2020-06-20
      	描述：diy组件-模拟显示-导航组
      -->
    <div @click.stop="$parent.$parent.onEditer(index)">
      <div class="drag optional" :class="{selected:index === selectedIndex}">
        <div class="diy-navBar" :style="{background:item.style.background}">
          <ul class="list" :class="'column-'+item.style.rowsNum">
            <li class="item" :key="index" v-for="(navBar,index) in item.data">
              <div class="item-image" v-if="Number(navBar.icon_type) === 20">
                <img v-img-url="navBar.imgUrl">
              </div>
              <div class="icon-box" :style="{'background': Number(navBar.colorConf) === 20 ? 'linear-gradient(135deg, '+navBar.color1+' 10%, '+navBar.color2+' 70%, '
              +navBar.color3+' 90%)' :(Number(navBar.colorConf) === 10 ?navBar.solidColor: navBar.theme_colors) }" v-else>
                <i :class="navBar.icon"></i>
              </div>
              <div class="item-text text-ellipsis" :style="{color:navBar.color}">
                {{navBar.text}}
              </div>
              <i class="icon iconfont2 icon-right"></i>
            </li>
          </ul>
        </div>
        <div class="btn-edit-del">
          <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['item', 'index', 'selectedIndex'],
    methods: {

    }
  };
</script>

<style lang="scss" scoped>
@import '../../../../../components/page/static/iconfont2.css';
.diy-navBar .list{ display: flex; flex-wrap: wrap; align-items: flex-start;}
.diy-navBar .list .item{ padding: 10px 0; display: flex; justify-content: center; align-items: center; flex-direction: column;}
.diy-navBar .list.column-1 .item{
  width: 100%;
  border-bottom: #cccccc 1px solid;
  display: inline;
  margin-left: 12px;
  .item-text {
    display: inline;
    height: 30px;
  }
  .item-image {
    display: inline;
    width: 30px;
    height: 30px;
    vertical-align: middle;
    img {
      display: inline;
      width: 30px;
      border-radius: 50%;
    }
  }
  .icon.iconfont2.icon-right {
    margin-right: 5px;
    float: right;
  }
}
.diy-navBar .list.column-2 .item{
  width: 50%;
  .item-text {
    width: 100%; padding: 4px 0; text-align: center;
  }
  .icon.icon-right{display: none}
  .item-image {
    width: 30px;
    height: 30px;
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
}
.diy-navBar .list.column-3 .item{
  width: 33.333333333%;
  .item-text {
    width: 100%; padding: 4px 0; text-align: center;
  }
  .icon.icon-right{display: none}
  .item-image {
    width: 30px;
    height: 30px;
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
}
.diy-navBar .list.column-4 .item{
  width: 25%;
  .item-text {
    width: 100%; padding: 4px 0; text-align: center;
  }
  .icon.icon-right{display: none}
  .item-image {
    width: 30px;
    height: 30px;
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
}
.diy-navBar .list.column-5 .item{
  width: 20%;
  .item-text {
    width: 100%; padding: 4px 0; text-align: center;
  }
  .icon.icon-right{display: none}
  .item-image {
    width: 30px;
    height: 30px;
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
}
//.diy-navBar .list .item-image {
//  width: 30px;
//  height: 30px;
//}
//.diy-navBar .list .item-image img {
//  width: 100%;
//  border-radius: 50%;
//}
//.diy-navBar .list .item-text{ width: 100%; padding: 4px 0; text-align: center;}
.icon-box {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #ffffff;
  display: inline-block;
  text-align: center;
  i {
    font-size: 20px;
    color: #ffffff;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/NavBar.vue